<template>
  <div class="app-container">
    <HeaderView />
    <router-view />
    <FooterView />
    <FixedView :show="isShowUp" />
  </div>
</template>

<script>
export default {
  name: 'App',
  components: {
    HeaderView: () => import('@/components/HeaderView/header-view.vue'),
    FooterView: () => import('@/components/FooterView/footer-view.vue'),
    FixedView: () => import('@/components/FixedView/fixed-view.vue'),
  },
  data() {
    return {
      isShowUp: false,
    }
  },
  mounted() {
    window.addEventListener('scroll', this.scrollEvent, true);
  },
  methods: {
    // 滚动事件
    scrollEvent() {
      // 滚动条距离顶部的距离
      let top = window.pageYOffset;
      if (top > 800) return this.isShowUp = true;
      this.isShowUp = false;
    }, 
  }
}
</script>

<style>
.router-view {
  flex: 1;
}
</style>